<template>
    <canvas :height="chartHeight"></canvas>
</template>

<script>
    import Chart from 'chart.js';
    import ChartMixin from './../../mixins/chart';

    export default {
        data() {
            return {
                chart: {},
                graphType: 'bar',
            }
        },

        mixins: [ChartMixin],

        props: {
            type: {
                type: String,
                default: 'bar',
            },

            title: {
                type: String,
            },

            labels: {
                required: true,
                type: Array,
            },

            datasets: {
                required: true,
                type: Array,
            },

            displayLegend: {
                type: Boolean,
                default: true
            },

            height: {
                type: Number,
            },

            yAxisWidth: {
                type: Number,
                default: 130,
            },

            yAxisVisible: {
                type: Boolean,
                default: true
            },

            beginAtZero: {
                type: Boolean,
                default: false,
            },

            displayGridlines: {
                type: Boolean,
                default: true,
            },

            enableTooltips: {
                type: Boolean,
                default: true,
            }
        },

        watch: {
            datasets() {
                this.redraw();
            }
        },

        mounted() {
            bus.$on('update-charts', function () {
                this.redraw();
            }.bind(this));

            this.draw();
        },

        computed: {
            chartHeight() {
                if (typeof this.height == 'undefined') return '';

                return this.height;
            },
        },

        methods: {
            draw() {
                this.chart = new Chart(this.$el.getContext('2d'), {
                    type: this.type,
                    data: {
                        labels: this.labels,
                        datasets: this.datasets,
                    },
                    options: {
                        tooltips: {
                            mode: 'index',
                            intersect: true,
                            enabled: this.enableTooltips,
                        },
                        legend: {
                            display: this.displayLegend,
                        },
                        scales: {
                            yAxes: [{
                                display: this.yAxisVisible,

                                afterFit: function (scaleInstance) {
                                    scaleInstance.width = this.yAxisWidth;
                                }.bind(this),

                                ticks: {
                                    beginAtZero: this.beginAtZero,
                                },

                                gridLines: {
                                    display: this.displayGridlines,
                                }
                            }],

                            xAxes: [{
                                gridLines: {
                                    display: this.displayGridlines,
                                },
                            }],
                        },
                        maintainAspectRatio: false,
                    }
                })

                _.defer(() => {
                    this.getAsImage();
                })
            },
        }
    }
</script>